import React, { useRef } from "react";
import "../../Assets/Css/Department.scss";
import Table from "../../Components/Table";
import { useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import qs from "query-string";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import AddDepartmentModal from "../../Components/AddDepartmentModal";
import Listicon from "../../Assets/Images/Designation/listIcon";
import DesignationIcon from "../../Assets/Images/Designation/DesignationIcon";
import { addDepartment, getDepartments, updateDepartment } from "../../Services/Department/action";
import { getUsers } from "../../Services/Users/action";
import { deleteRecord } from "../../Services/Delete/action";
import { Tree, getBackendOptions, MultiBackend } from "@minoru/react-dnd-treeview";
import { Tree as OrganizedTree, TreeNode as OrgNode } from "react-organizational-chart";
import { FaUserTie } from "react-icons/fa";
import { DndProvider } from 'react-dnd';
import { FaArrowRightLong } from 'react-icons/fa6';
import ModulesList from "../../Assets/ModulesLiist";
import FeaturesList from "../../Assets/FeaturesList";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../Lib/RoleWiseFeatureWrapper";
import { getDesignations } from "../../Services/Designation/action";
import Skeleton from "react-loading-skeleton";

const ChartNode = ({ label, designations = [] }) => (
    <div style={{
        border: "1px solid #ccc",
        padding: 8,
        borderRadius: 4,
        minWidth: '200px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa'
    }}>
        <div style={{
            fontWeight: 'bold',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <FaUserTie style={{ marginRight: '5px' }} /> {label}
        </div>
        {designations.length > 0 && (
            <div style={{
                fontSize: '12px',
                color: '#666',
                borderTop: '1px solid #eee',
                paddingTop: '5px'
            }}>
                {designations.map((designation, index) => (
                    <div key={index} style={{ margin: '2px 0' }}>
                        {designation}
                    </div>
                ))}
            </div>
        )}
    </div>
);

const Department = (props) => {
    const [checked, setChecked] = useState(false);
    const [selectedId, setSelectedId] = useState([]);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [activeButton, setActiveButton] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [treeData, setTreeData] = useState([]);

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Department,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Department,
        Featur_Name: FeaturesList.Delete,
    });

    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Department,
        Featur_Name: FeaturesList.Update,
    })
    const location = useLocation();
    const data = location?.state?.data?.allData;

    const fileInputRef = useRef(null);
    const modalRef = useRef(null);

    const navigate = useNavigate()

    useEffect(() => {
        const path = location.pathname.slice(1);
        setActiveButton(path)
    }, []);

    const handleClickBtn = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    const header = [
        { field: "Name" },
        { field: "Designation" },
        { field: "Parent Department" },
        { field: "Action" },
    ];

    let footer = true;
    let count = inData?.length;

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props.getDepartmentList();
            await props?.getDesignationList();
            await props?.getUsers({ module: 'department' });
        } catch (error) {
            console.error("Error fetching departments:", error);
        }
    };

    useEffect(() => {
        setIsLoading(true)
        fetchData();
        setIsLoading(false)
    }, [location.search]);

    const Designation = props?.designation?.map((item) => {
        return {
            value: item?.name,
            label: item?.name
        }
    }) || [];

    const createTreeData = (departments) => {
        if (!departments || departments.length === 0) {
            console.log("No departments data available");
            return [];
        }

        const nameToIdMap = {};
        departments.forEach((dept) => {
            nameToIdMap[dept.name] = dept.id;
        });


        const treeNodes = departments.map((department) => {
            const parentId = department.parent_department
                ? nameToIdMap[department.parent_department] || 0
                : 0;

            return {
                id: department.id,
                parent: parentId,
                droppable: true,
                text: department.name,
                designations: department.designations || []
            };
        });

        return treeNodes;
    };

    useEffect(() => {
        const tableData = props.department.map((department) => ({
            checkbox: {
                value: department?.id,
                type: "checkbox",
            },
            "Name": {
                value: department?.name,
                type: "text",
            },
            "Designation": {
                value: department?.designations?.map(d => d.name).join(', ') || '-',
                type: "text",
            },
            "Parent Department": {
                value: department?.parent_department || '-',
                type: "text",
            },
            Action: {
                value: "/department",
                value2: "/department/view",
                value3: department?.id,
                type: "action",
            },
            allData: {
                ...department
            }
        }));
        setInData(tableData);

        const treeNodes = createTreeData(props.department);
        setTreeData(treeNodes);
    }, [props?.department]);

    const handleClose = () => {
        setShowModal(false);
        setFileName('');
        setSelectedFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
                // await handlePdfDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const [isModalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        if (data) {
            setModalVisible(true);
        }
    }, [data]);

    const openModal = () => {
        setModalVisible(true);
    }

    const closeModal = async () => {
        setModalVisible(false);
        navigate(location.pathname, { replace: true, state: {} });
    };

    const applyFilters = ({ search }) => {
        const filtered = inData?.filter((department) => {
            let matchesSearch = true;

            if (search) {
                matchesSearch = department?.Name?.value?.toLowerCase().includes(search.toLowerCase());
            }

            return matchesSearch;
        });

        setFilteredData(filtered);
    };

    const searchFiled = (e) => {
        const { value } = e.target;
        setSearchTerm(value);
        applyFilters({ search: value });
    };

    const handleClear = () => {
        setSearchTerm("");
        setFilteredData([]);
    };


    const renderOrgChart = (nodeId) => {
        const node = treeData.find((n) => n.id === nodeId);
        if (!node) return null;

        const children = treeData.filter((n) => n.parent === nodeId);
        const departmentData = props?.department?.find(dept => dept.id === nodeId);
        const designations = departmentData?.designations?.map(d => d.name) || [];

        return (
            <OrgNode label={<ChartNode label={node.text} designations={designations} />} key={node.id}>
                {children.map((child) => renderOrgChart(child.id))}
            </OrgNode>
        );
    };



    return (
        <div className="department-main">
            <div className="page-title">
                <h4>
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width={200} height={40} />
                        ) : (
                            "Department"
                        )
                    }
                </h4>
                <div>
                    {
                        props.loading ? (
                            <Skeleton className="badge rounded-pill" width={100} height={40} />
                        ) : (
                            <RoleWiseFeatureWrapper
                                modules={props?.modules}
                                features={props?.features}
                                user={props?.user}
                                ModuleName={ModulesList.Department}
                                Featur_Name={FeaturesList.Create}>
                                <button className="custom-department-btn" disabled={props.loading} onClick={openModal}>
                                    {props.loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : "Add Department"}
                                </button>
                            </RoleWiseFeatureWrapper>
                        )
                    }
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4">
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width="100%" height={40} />
                        ) : (
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="input-css"
                                    name='departmentname'
                                    placeholder='Search Department'
                                    value={searchTerm}
                                    onChange={searchFiled}
                                />
                            </div>
                        )
                    }
                </div>
                <div className="col-lg-4">
                    {searchTerm && (
                        props.loading ? (
                            <Skeleton className="badge rounded-pill" width={100} height={40} />
                        ) : (
                            <button
                                type="submit"
                                className='custom-department-btn'
                                onClick={handleClear}>
                                Clear
                            </button>
                        )
                    )}
                </div>
            </div>

            <div className="department-export-btn">
                <div>
                    {/* Export buttons can be added here */}
                </div>

                <div>
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width={50} height={40} />
                        ) : (
                            <div className="navigation_btn mb-3">
                                <button
                                    className={`btn1 ${activeButton === "department" ? "active" : ""}`}
                                    onClick={() => handleClickBtn("department", "/department")}
                                >
                                    <Listicon color={activeButton === "department" ? "white" : "black"} bgColor={activeButton === "department" ? "black" : "white"} />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === "departmenthierarchy" ? "active" : ""}`}
                                    onClick={() => handleClickBtn("departmenthierarchy", "/departmenthierarchy")}
                                >
                                    <DesignationIcon color={activeButton === "departmenthierarchy" ? "white" : "black"} bgColor={activeButton === "departmenthierarchy" ? "black" : "white"} />
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>

            {location?.pathname === '/department' && (
                <div className="invoice-table-part">
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" count={5} width="100%" height={40} />
                        ) : (
                            <Table
                                header={header}
                                data={searchTerm ? filteredData : inData}
                                footer={footer}
                                count={count}
                                checked={checked}
                                records={count}
                                totalSelectedIds={totalSelectedIds}
                                defaultParams={params}
                                selectedId={selectedId}
                                handleChange={handleChange}
                                loading={props.loading}
                                deleteRecord={props?.deleteRecord}
                                showIsEdit={canEdit}
                                showIsDelete={canDelete}
                                showIsView={canView}
                            />
                        )
                    }
                </div>
            )}

            {location.pathname === "/departmenthierarchy" && (
                <div className="row">
                    <div className="col-md-12 col-lg-12 col-12">
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width="100%" height="50vh" />
                            ) : (
                                <div className="departmenthierarchy-main">
                                    <div className="content-part">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="left-part">
                                                    <p className='title-part'>Hierarchy View</p>

                                                    {treeData.length > 0 ? (
                                                        <div className="d-flex tree">
                                                            {treeData
                                                                .filter((n) => n.parent === 0)
                                                                .map((n) => (
                                                                    <OrganizedTree
                                                                        key={n.id}
                                                                        treeLineColor="#777"
                                                                        treeLineWidth="2px"
                                                                        treeLineBorderRadius="10px"
                                                                    >
                                                                        {renderOrgChart(n.id)}
                                                                    </OrganizedTree>
                                                                ))}
                                                        </div>
                                                    ) : (
                                                        <div style={{
                                                            padding: '20px',
                                                            textAlign: 'center',
                                                            color: '#666',
                                                            border: '1px dashed #ccc',
                                                            borderRadius: '4px'
                                                        }}>
                                                            {props.loading ? 'Loading hierarchy...' : 'No hierarchy data available.'}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            )}

            <AddDepartmentModal
                isModalVisible={isModalVisible}
                closeModal={closeModal}
                addDepartment={props?.addDepartment}
                loading={props?.loading}
                departmentData={data}
                updateDepartment={props?.updateDepartment}
                designations={props?.designation || []}
                departments={props?.department || []}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.departmentReducer.loading,
        department: state.departmentReducer.department,
        designation: state.designationReducer.designation,
        users: state.userReducer.users,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getUsers: (options) => {
            dispatch(getUsers(options));
        },
        getDepartmentList: () => {
            dispatch(getDepartments());
        },
        getDesignationList: () => {
            dispatch(getDesignations());
        },
        addDepartment: (data) => {
            dispatch(addDepartment(data));
        },
        updateDepartment: (id, data) => {
            dispatch(updateDepartment(id, data));
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue));
            await dispatch(getDepartments());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Department);